export const AUDITORY_MODEL = {
  paso: 5,
  pasoDescripcion: 'PASO_PAGO',
};
